import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class StudentLedgerPrevDuesService {
  readonly baseURL = sessionStorage.getItem('NbaseURLs');
  constructor(private http: HttpClient) { }

  //ViewStudLedgerDet(Admno: string, YearCode: Number): Observable<any> {
  ViewStudentPrevDuesDet(ShiftId: number, YearCode: number, CSCode: string, ofYear: String): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/ViewStudentPrevDuesDet?ShiftId=' + ShiftId + '&&YearCode=' + YearCode + '&&CSCode=' + CSCode + '&&ofYear=' + ofYear)
    .pipe(retry(1), catchError(this.handleError));
  }

  ViewStudLedgerDetC(ShiftId: number, YearCode: number, CSCode: string, FilterAmt: number): Observable<any> {
    debugger;
    //console.log(this.baseURL + '/ViewStudFeeDetailsDetAllsC?ShiftId=' + ShiftId + '&&YearCode=' + YearCode + '&&CSCode=' + CSCode + '&&FilterAmt=' + FilterAmt);
    return this.http.get<any>(this.baseURL + '/ViewStudFeeDetailsDetAllsC?ShiftId=' + ShiftId + '&&YearCode=' + YearCode + '&&CSCode=' + CSCode + '&&FilterAmt=' + FilterAmt)
      .pipe(retry(1), catchError(this.handleError));
  }

  ViewStudLedgerDetSum(ShiftId: number, YearCode: number, CSCode: string): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/ViewStudFeeDetailsDetAllSum?ShiftId=' + ShiftId + '&&YearCode=' + YearCode + '&&CSCode=' + CSCode)
      .pipe(retry(1), catchError(this.handleError));
  }

  GetCourses(): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/GetCourses?YearCode=' + parseInt(sessionStorage.getItem('YearCode')))
      .pipe(retry(1), catchError(this.handleError));
  }

  ViewStudFeeDetailsDet(Admno: string,YearCode: Number): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/ViewStudFeeDetailsDet?Admno=' + Admno + '&&YearCode=' + YearCode);
  }
  ViewStudFeeDetailsDetAll(): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/ViewStudFeeDetailsDetAll')
    .pipe(retry(1), catchError(this.handleError));
  }
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
